import MyInput from "../../App/MyInput/MyInput";
import {Regex} from "../../App/Regex";
import React from "react";

export const FormForgetPassword = ({ refSubmit, refForm, handleSubmit, alerts, setAlert }) => {

    return <form onSubmit={async (e) => {

        e.preventDefault()
        handleSubmit(e)
    }}>
        <MyInput
            label="Adresse mail"
            placeholder="adresse@mail.com"
            autocomplete="username"
            refForm={refForm}
            id="mail"
            name="mail"
            type="text"
            required={true}
            regex={Regex.mail}
        />
        {alerts ?? ''}
        <button className="btn btn-primary disabled" disabled={true} type={"submit"} ref={refSubmit}>Envoyer
        </button>
    </form>
}